import { WalletTransaction, WalletTransactionType } from "@app/core/wallet/domain/model/wallet-transaction";
import { DateMapper } from "@app/core/shared/data/network/date.mapper";


export class TransactionWSMapper {
  private static readonly KEY_ID = "id";
  private static readonly KEY_DATE = "date";
  private static readonly KEY_AMOUNT = "amount";
  private static readonly KEY_REMAINING_BALANCE = "remaining_balance";
  private static readonly KEY_TYPE = "type";
  private static readonly KEY_DESCRIPTION = "description";
  private static readonly KEY_CATEGORY = "category";
  
  private static readonly TRANSACTION_TYPES: Record<string, WalletTransactionType> = {
    "recharge": WalletTransactionType.RECHARGE,
    "spending": WalletTransactionType.SPENDING,
  };

  deserialize(data: Record<string, any>): WalletTransaction {
    return new WalletTransaction(
        data[TransactionWSMapper.KEY_ID],
        DateMapper.deserialize(data[TransactionWSMapper.KEY_DATE]),
        data[TransactionWSMapper.KEY_AMOUNT],
        data[TransactionWSMapper.KEY_REMAINING_BALANCE],
        TransactionWSMapper.TRANSACTION_TYPES[data[TransactionWSMapper.KEY_TYPE]],
        data[TransactionWSMapper.KEY_DESCRIPTION],
        data[TransactionWSMapper.KEY_CATEGORY]
    );
  }
}
